import * as React from 'react';
import Modal from '@medflex/components/stories/Modal';
import { trackEvent } from '@medflex/utils/Tracking';
import { IconAssistantAvatar, IconPhysicianAvatar } from '@medflex/components/stories/Icons';
import { useTranslation } from 'react-i18next';
import { STAFF_TYPES } from '@medflex/utils/constants';
import FeatureButton from '@medflex/components/stories/FeatureButton';
import Badge, { KINDS } from '@medflex/components/stories/Badge';
import { FEATURE_KEYS } from '@medflex/utils/subscriptionEnums';
import useIsWideScreen from '@medflex/hooks/useIsWideScreen';
import useFeatures from '../hooks/useFeatures';
import useModal from '../hooks/useModal';
import { MODALS } from '../hooks/useIsModal';

const StaffTypeModule = () => {
  const { open, close } = useModal();
  const isWideScreen = useIsWideScreen();
  const { t } = useTranslation('physician');
  const [staffPhysician, staffAssistant] = useFeatures([
    FEATURE_KEYS.STAFF_PHYSICIAN,
    FEATURE_KEYS.STAFF_ASSISTANT,
  ]);

  const handleClose = event => {
    trackEvent(event, { zone: 'StaffMemberTypeEdit | form', actionText: 'close' });
    close({ modal: 'staff_type' });
  };

  const handleStaffPhysicianCLick = () =>
    open({
      modal: MODALS.staff_member,
      subType: STAFF_TYPES.PHYSICIAN,
    });

  const handleStaffAssistantCLick = () =>
    open({
      modal: MODALS.staff_member,
      subType: STAFF_TYPES.ASSISTANT,
    });

  return (
    <Modal showCloseButton onClickCloseButton={handleClose} data-component="StaffTypeModule">
      <div className="flex flex-col">
        <h2 className="font-semibold text-xl mb-12">{t('StaffTypeModule.title')}</h2>
        <FeatureButton
          isWideScreen={isWideScreen}
          title={t('StaffTypeModule.physician.title', { allowHtml: true })}
          icon={<IconPhysicianAvatar size="8" />}
          className="mb-6"
          subtitle={t('StaffTypeModule.physician.description')}
          onClick={
            !staffPhysician.active
              ? () => open({ modal: MODALS.featureUpgradeStaffPhysician })
              : handleStaffPhysicianCLick
          }
          badge={!staffPhysician.active && <Badge kind={KINDS.SIGNAL}>Upgrade</Badge>}
        />
        <FeatureButton
          isWideScreen={isWideScreen}
          title={t('StaffTypeModule.assistant.title')}
          icon={<IconAssistantAvatar size="8" />}
          className="mb-6"
          subtitle={t('StaffTypeModule.assistant.description')}
          onClick={
            !staffAssistant.active
              ? () => open({ modal: MODALS.featureUpgradeStaffAssistant })
              : handleStaffAssistantCLick
          }
          badge={!staffAssistant.active && <Badge kind={KINDS.SIGNAL}>Upgrade</Badge>}
        />
      </div>
    </Modal>
  );
};

export default StaffTypeModule;
